import { FC } from 'react';
import Link from 'next/link';
import styles from './BooksBtn.module.scss';

interface IBooksBtn {
  alias: string;
  title: string;
}

const BooksBtn: FC<IBooksBtn> = ({ alias, title }) => {
  return (
    <Link prefetch={false} className={styles.booksBtn} href={alias}>
      {title}
    </Link>
  );
};
export default BooksBtn;
